import(/* webpackMode: "eager", webpackExports: ["ConsultButton"] */ "/vercel/path0/components/site/consult-button.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MealTabs"] */ "/vercel/path0/components/special-meals/meal-tabs.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
